import { Col, FormGroup, Row } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getTelephoneNumberError } from '@frontend/utils';
import { TextInputField } from './processActivityFormGroupFields';

export type PhoneNumberData = {
    homePhoneNumber: string | null;
    mobileNumber: string | null;
};

type PhoneNumberFormGroupProps = {
    data: PhoneNumberData;
    errors: ValidationErrors;
    onChange: (data: PhoneNumberData, validateKeys?: string | string[] | undefined) => void;
};

export function PhoneNumberFormGroup({ data, errors, onChange }: PhoneNumberFormGroupProps) {
    const translate = getSelectedLanguage();

    // @TODO this component misses still an onBlur re-validate.
    return (
        <FormGroup
            hasErrors={errors.has('patient.mobileNumber') || errors.has('patient.homePhoneNumber')}
            isRequired={true}
            label={translate.common.phoneNumbers}
        >
            <Row
                columnGap={3}
                rowGap={3}
            >
                <Col span={[12, 6]}>
                    <TextInputField
                        error={getTelephoneNumberError(errors.get('patient.mobileNumber'))}
                        fieldKey="patient.mobileNumber"
                        onChange={(value) =>
                            onChange({
                                homePhoneNumber: data.homePhoneNumber,
                                mobileNumber: value,
                            })
                        }
                        placeholder={translate.common.mobileNumber}
                    />
                </Col>
                <Col span={[12, 6]}>
                    <TextInputField
                        error={getTelephoneNumberError(errors.get('patient.homePhoneNumber'))}
                        fieldKey="patient.homePhoneNumber"
                        onChange={(value) => onChange({ homePhoneNumber: value, mobileNumber: data.mobileNumber })}
                        placeholder={translate.common.homeNumber}
                    />
                </Col>
            </Row>
        </FormGroup>
    );
}
